export default __webpack_public_path__ + "static/toolbar-dark-17ce4ca6c2fc3aabae18fc2df697c38e04be3ae4f36a7d6bb5a32db97cff6633.mp4";